import React, { useEffect, useRef } from 'react';
import SubIndex from '../sub-index';

import { DialogBg, DialogBox } from '../styles/layOutStyles';

const Dialog = ({ children, open, close, style }) => {
  const dialogBgRef = useRef();
  const dialogRef = useRef();

  useEffect(() => {
    if (open) {
      dialogBgRef.current.addEventListener('click', currentTargetClick);

      return () => dialogBgRef.current.removeEventListener('click', currentTargetClick);
    }
  }, [open]);

  const currentTargetClick = ({ target }) => {
    if (dialogRef.current) {
      if (!dialogRef.current.contains(target)) {
        if (close) {
          close();
        }
      }
    }
  };

  return (
    <SubIndex>
      <DialogBg ref={dialogBgRef} open={open}>
        <DialogBox ref={dialogRef} style={style}>
          {children}
        </DialogBox>
      </DialogBg>
    </SubIndex>
  );
};

export default Dialog;
